import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getMyReviews } from '../services/my-reviews.service';

const PAGE_SIZE = 10;

export function useMyReviews(page: number) {
  return useQuery({
    queryKey: ['my-reviews', page],
    queryFn: () => getMyReviews(page, PAGE_SIZE),
    placeholderData: keepPreviousData,
  });
}
